// extracted by mini-css-extract-plugin
export default {"company":"company_company__WpDOt","active":"company_active__s6haN"};